<div ref="manage_workflow" :key="`entity-${application_id}-${entity_profile_id}-${$route.fullPath}`">
  <NavigationBackButton />
  <div class="px-3">
    <div class="card-header bg-white card-nav-tabs border-0 shadow mt-2 rounded-top-lg ms-2 mb-2">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Left Side: Founder Info -->
        <div class="d-flex align-items-center">
          <i class="bx bx-user fs-4 text-dark me-2"></i>
          <div class="d-flex flex-column justify-content-center">
            <p class="fw-bold text-dark mb-0 text-x">{{ entity_name }}</p>
            <div class="d-flex align-items-center gap-2">
              <span class="text-xs fw-bold" :style="{ color: get_status_color(application_status) }">
                {{ application_status }}
              </span>

              <span v-if="is_master_registered && display_trust_number" class="badge text-xs fw-bold px-2 py-1" :style="{ 
                    backgroundColor: get_status_color(application_status) + '20',
                    color: get_status_color(application_status),
                    border: `1px solid ${get_status_color(application_status)}`
                }">
                    TRUST: {{ display_trust_number }}
              </span>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end align-items-center">
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark" data-bs-toggle="modal"
            data-bs-target="#application_profile_logs" @click="open_log_modal">
            Logs
          </button>
        </div>
      </div>
    </div>

    <div class="overview-application-container">
      <!-- Scrollable Floating Tabs -->
      <div class="overview-tabs-wrapper overview-scrollable-container">
        <div class="overview-vertical-tabs-container">
          <div
            v-for="tab in visible_tabs"
            :key="tab.id"
            class="overview-floating-tab shadow rounded-lg"
            :class="{ active: active_tab === tab.id }"
            @click="select_tab(tab.id)"
            :data-tooltip="tab.name"
          >
            <div class="overview-floating-tab-inner">
              <span class="text-xs">{{ tab.name }}</span>
            </div>
          </div>
        </div>
      </div>


      <!-- Dropdown Section -->
      <div class="ms-2 overview-dropdown-column rounded-lg shadow-lg" v-if="active_tab_has_dropdown">
        <div class="overview-accordion-container mb-3 border-0 rounded-lg" id="stages_accordion">
          <div v-for="option in active_tab_dropdown_options" :key="option.value"
            class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">{{ option.label }}</span>
                </div>
                <a class="d-none fw-bold fs-6 p-0 ms-2 text-dark" @click.stop="toggle_dropdown(option.value)"
                  type="button">
                  <i class="bi" :class="{
                    'text-white bi-chevron-down': selected_dropdown !== option.value,
                    'text-white bi-chevron-up': selected_dropdown === option.value
                  }"></i>
                </a>
              </div>
            </h2>

            <div class="collapse" :class="{ show: selected_dropdown === option.value }">
              <div class="accordion-body">
                <div v-if="is_db_main_section_tab(selected_dropdown)">
                  <div>
                    <RenderSections :form_main_section_id="dropdown_forms_id(selected_dropdown)"
                      :application_id="application_id" :application_form_id="application_form_id"
                      :entity_profile_id="entity_profile_id" />
                  </div>
                </div>

                <div v-if="selected_dropdown === 'Overview'">
                  <ApplicationVerification @status-updated="handle_status_updated" @trust-number-updated="handle_trust_number_updated" />
                </div>
                <!-- Add Attributes component here -->
                <div v-if="selected_dropdown === 'Attributes'">
                  <ApplicationAttributes :application-id="application_id" :entity-profile-id="entity_profile_id" />
                </div>
                <div v-if="selected_dropdown === 'Verification'">
                  <VerificationOverview :application_form_id="application_form_id" />
                </div>
                <div v-if="selected_dropdown === 'E-Signing'">
                  <ESigning :application_id="application_id" />
                </div>
                <div v-if="selected_dropdown === 'compliance'">
                  <ViewComplianceChecks :application_id="entity_id" />
                </div>
                <div v-if="selected_dropdown === 'Documents'">
                  <DocumentManagement :application_form_id="application_form_id" />
                </div>
                <div v-if="selected_dropdown === 'Requests'">
                  <ViewRequests />
                </div>
                <div v-if="selected_dropdown === 'Assignment'">
                  <ApplicationAssignment />
                </div>
                <div v-if="selected_dropdown === 'Journal'">
                  <ApplicationJournal />
                </div>
                <!-- Sub-Entities Section -->
                <div v-if="selected_dropdown === 'Sub-Entities'">
                  <div class="card border-0">
                    <div class="card-body p-0">
                      <!-- FolderList component for sub-entities -->
                      <button @click="prepare_assign_modal(current_entity)" data-bs-toggle="modal"
                        data-bs-target="#assign_sub_entity_modal"
                        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark ms-3 mb-3">
                        Add Sub-Entity
                      </button>

                      <FolderList v-if="displayed_applications_list.length" :items="displayed_applications_list"
                        :application-id="application_id" :entity-profile-id="entity_profile_id"
                        :entity-type-id="entity_type_id" :hint-on-desktop="true"
                        @view="redirect_to_application_overview" @add-sub="handle_folderlist_add"
                        @view_logs="open_log_modal" @fetch-assigned="fetch_assigned_for_item"
                        :is-loading="is_loading_sub_entity" />

                      <!-- Loading and empty states -->
                      <div v-else class="text-center py-5 text-muted">
                        <div v-if="is_loading_sub_entity" class="py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          <p class="mt-2">Loading sub-entities...</p>
                        </div>
                        <div v-else>
                          <i class="fa-solid fa-inbox fa-3x mb-3"></i>
                          <p>No sub-entities found</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Log Modal -->
<teleport to="body">
  <div class="modal fade" id="application_profile_logs" tabindex="-1"
    aria-labelledby="application_profile_logs_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
          <h5 class="modal-title text-white text-xxs m-0" id="assign_sub_entity_modal_label">Application Timeline</h5>
          <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-3">
          <!-- Main Entity (readonly for context) -->
          <div class="timeline-modal-body">
            <ApplicationLog :status="selected_log_status" :user_id="user_id" />
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>


<!-- Assign Sub Entity Modal -->
<teleport to="body">
  <div class="modal fade" id="assign_sub_entity_modal" tabindex="-1" aria-labelledby="assign_sub_entity_modal_label"
    aria-hidden="true" ref="assignSubEntityModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
          <h5 class="modal-title text-white text-xxs m-0" id="assign_sub_entity_modal_label">Add Sub-Entity</h5>
          <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-3">
          <!-- Main Entity (readonly for context) -->
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Parent Entity Type</label>
            <input type="text" class="modal-form-control form-control text-xxs"
              :value="current_form.parent_name || 'Loading...'" disabled>
          </div>

          <!-- Sub-Entity Type (under the selected parent) -->
          <div class="modal-form-group form-group mb-3">
            <label for="assign_sub_entity_type" class="modal-form-label form-label text-xxs">Sub-Entity Type</label>
            <select id="assign_sub_entity_type"
              class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
              v-model="assign_sub_entity_type_id" @change="assign_on_sub_entity_change"
              :disabled="assign_sub_entity_options.length === 0 || is_loading_options">
              <option value="" disabled selected>Select sub-entity type</option>
              <option v-for="opt in assign_sub_entity_options" :key="opt.id" :value="opt.id">
                {{ opt.name }}
              </option>
            </select>
            <div v-if="is_loading_options" class="text-info text-xxs mt-1">
              <i class="fas fa-spinner fa-spin me-1"></i>Loading sub-entity types...
            </div>
            <div v-if="assign_sub_entity_options.length === 0 && !is_loading_options" class="text-danger text-xxs mt-1">
              No sub-entity types available for this parent entity.
            </div>
          </div>

          <!-- Forms (populated from the chosen sub-entity type) -->
          <div class="modal-form-group form-group mb-3" v-if="assign_form_list.length">
            <label for="assign_form_select" class="modal-form-label form-label text-xxs">Form</label>
            <select id="assign_form_select"
              class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
              v-model="assign_selected_form_id" :disabled="assign_form_list.length === 0">
              <option value="" disabled selected>Select form</option>
              <option v-for="form in assign_form_list" :key="form.id" :value="form.id">
                {{ form.form_name }}
              </option>
            </select>
          </div>
          <div class="modal-form-group form-group mb-3" v-else-if="assign_sub_entity_type_id">
            <label class="modal-form-label form-label text-xxs">Form</label>
            <div class="alert alert-info text-xxs p-2">
              Select a sub-entity type to see available forms
            </div>
          </div>

          <!-- Sub-Entity Name -->
          <div class="modal-form-group form-group mb-3">
            <label for="assign_entity_name" class="modal-form-label form-label text-xxs">Sub-Entity Name</label>
            <input id="assign_entity_name" type="text" v-model="assign_entity_name"
              class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
              placeholder="Enter Sub-Entity Name">
          </div>

          <!-- Toggle for showing the email field -->
          <div class="modal-form-group form-group mb-3">
            <div class="form-check form-switch text-xxs d-flex justify-content-start align-items-center">
              <input type="checkbox" id="email_toggle" v-model="include_email" class="form-check-input" role="switch">
              <label class="form-check-label ms-2" for="email_toggle">
                Allow login - Create user account with email invitation
              </label>
            </div>
            <small class="form-text text-muted text-xxs">
              When enabled, the entity will be able to log in and complete their own forms
            </small>
          </div>

          <!-- Email -->
          <div class="modal-form-group form-group mb-3" v-if="include_email">
            <label for="assign_email" class="modal-form-label form-label text-xxs">Email</label>
            <input id="assign_email" type="email" v-model="assign_email"
              class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
              placeholder="Enter Email">
          </div>

          <!-- Footer -->
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button type="button" class="btn btn-primary-dark btn-sm px-3 text-xxs shadow-sm"
              @click="save_assign_sub_entity">
              <span v-if="isSaving">
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Saving...
              </span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>